import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faBox } from '@fortawesome/free-solid-svg-icons';

export interface NavFaIcon {
  name: IconDefinition;
  type: 'fa';
}

export interface NavMatIcon {
  name: string;
  type: 'mat';
}

export interface NavigationItem {
  featureFlag?: string;
  icon: NavFaIcon | NavMatIcon;
  label: string;
  link: string;
  requiresAdmin?: boolean;
}

export const NavigationItems: Readonly<NavigationItem[]> = [
  {
    icon: { name: faBox, type: 'fa' },
    label: 'Orders',
    link: '/'
  },
  {
    icon: { name: 'map', type: 'mat' },
    label: 'Live Map',
    link: '/live-map'
  },
  {
    icon: { name: 'notifications', type: 'mat' },
    label: 'Alerts',
    link: '/alerts'
  },
  {
    icon: { name: 'people_alt', type: 'mat' },
    label: 'User Mgmt',
    link: '/user-management'
  },
  {
    icon: { name: 'attach_money', type: 'mat' },
    label: 'Billing',
    link: '/billing',
    requiresAdmin: true
  }
];
